import React from 'react';

const MortgageRefinementAmountFilterIcon = (props: any) => (
  <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g clipPath="url(#clip0_1372_8768)">
      <path
        d="M4.66665 14.9999L2.99998 13.3333L1.33331 14.9999"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.66667 18.6666H4.33333C3.97971 18.6666 3.64057 18.5261 3.39052 18.2761C3.14048 18.026 3 17.6869 3 17.3333V13.3333"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <g clipPath="url(#clip1_1372_8768)">
      <path d="M15.3333 5L17 6.66667L18.6666 5" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path
        d="M13.3333 1.33325H15.6666C16.0203 1.33325 16.3594 1.47373 16.6095 1.72378C16.8595 1.97382 17 2.31296 17 2.66659V6.66658"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <path d="M15 10.4167V19.5834" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path
      d="M17.0833 12.0835H13.9583C13.5716 12.0835 13.2006 12.2371 12.9271 12.5106C12.6536 12.7841 12.5 13.1551 12.5 13.5418C12.5 13.9286 12.6536 14.2995 12.9271 14.573C13.2006 14.8465 13.5716 15.0002 13.9583 15.0002H16.0417C16.4284 15.0002 16.7994 15.1538 17.0729 15.4273C17.3464 15.7008 17.5 16.0717 17.5 16.4585C17.5 16.8453 17.3464 17.2162 17.0729 17.4897C16.7994 17.7632 16.4284 17.9168 16.0417 17.9168H12.5"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <g clipPath="url(#clip2_1372_8768)">
      <path
        d="M1.25 3.74992L5 0.833252L8.75 3.74992V8.33325C8.75 8.55427 8.6622 8.76623 8.50592 8.92251C8.34964 9.07879 8.13768 9.16659 7.91667 9.16659H2.08333C1.86232 9.16659 1.65036 9.07879 1.49408 8.92251C1.3378 8.76623 1.25 8.55427 1.25 8.33325V3.74992Z"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M3.75 9.16667V5H6.25V9.16667" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </g>
    <defs>
      <clipPath id="clip0_1372_8768">
        <rect width="8" height="8" fill="white" transform="translate(0 12)" />
      </clipPath>
      <clipPath id="clip1_1372_8768">
        <rect width="8" height="8" fill="white" transform="translate(12)" />
      </clipPath>
      <clipPath id="clip2_1372_8768">
        <rect width="10" height="10" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default MortgageRefinementAmountFilterIcon;
